import NumberRangeBaseController from './number_range_base_controller';

export default class extends NumberRangeBaseController {}
